import React from 'react';
import { EmptyListView } from 'components/ui/EmptyListView/EmptyListView';
import { PeopleTabValue } from '../types';
import { AddButton } from './AddButton';
import { Box } from '@razorpay/blade/components';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import useReduxSelector from 'utils/useReduxSelector';
import { getContractorText } from 'utils/getContractorText';

export const EmptyList = ({ activeTab }: { activeTab: PeopleTabValue }) => {
  const isRxCurrentAccountMerchant = !!useReduxSelector(loggedInUserSelectors.currentOrganization)
    ?.isRxCurrentAccountMerchant;
  const featureFlags = useReduxSelector(loggedInUserSelectors.features);

  const { contractors } = getContractorText({
    isRxCurrentAccountMerchant,
    featureFlags,
  });

  if (activeTab === 'search') {
    return <EmptyListView title="No results found" />;
  }
  if (activeTab === 'active' || activeTab === 'employees') {
    return (
      <EmptyListView
        title="No employees added yet"
        description="Add your first employee to get started"
        backgroundColor="transparent">
        <Box display="flex" justifyContent="center">
          <AddButton />
        </Box>
      </EmptyListView>
    );
  }
  if (activeTab === 'contractors') {
    return <EmptyListView title={`No ${contractors} added yet`} backgroundColor="transparent" />;
  }
  if (activeTab === 'drafts') {
    return <EmptyListView title="No employees in drafts" backgroundColor="transparent" />;
  }
  if (activeTab === 'dismissed') {
    return <EmptyListView title="No dismissed employees" backgroundColor="transparent" />;
  }
  return <EmptyListView title="No results found" backgroundColor="transparent" />;
};
